import Dispatcher from '../dispatcher';
import resolvePromise from '../helper/resolved_promise';

const TranslationActions = {
    updateAction(translations) {
        Dispatcher.handleTranslationAction({
            type: 'UPDATE_TRANSLATIONS',
            payload: translations,
        });

        return resolvePromise();
    },
};

export default TranslationActions;
